import type { PackingInvoiceRow } from '@/infrastructure/FulfillmentAdminClient';

/**
 * Row rules the printed sheets share: the PACKING sheet (View Orders Print, Order Detail's Print Packing
 * Label and its Packing Invoice preview) and the READY TO BE OUTBOUNDED pick list all mark counts and walk
 * shelves the same way, so the rules live here once [SSD-7207].
 */

/** A shelf pull of more than one unit is the line a picker most often short-picks, so the sheets make it loud. */
export const isMultiUnit = (qty: number): boolean => qty >= 2;

/** What the server prints in place of a shelf it could not resolve; the sheets print it as a hyphen. */
export const NO_LOCATION = '—';

export const hasLocation = (row: Pick<PackingInvoiceRow, 'locationCode'>): boolean =>
  row.locationCode.trim() !== '' && row.locationCode !== NO_LOCATION && row.locationCode !== '-';

/** Shelved rows in location order, then rows with no shelf, then the sample set: the packer's walk order. */
const walkRank = (row: PackingInvoiceRow): number => (row.isSampleSet ? 2 : hasLocation(row) ? 0 : 1);

export const byWalkOrder = (a: PackingInvoiceRow, b: PackingInvoiceRow): number =>
  walkRank(a) - walkRank(b) ||
  (walkRank(a) === 0 ? a.locationCode.localeCompare(b.locationCode, undefined, { numeric: true }) : 0);
